"use strict";

module.exports = {
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  CERTIFIED: 'CERTIFIED',
  APPROVED: 'APPROVED'
};